/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Participatedulworkshopdidacticreduction5Inputs */

const de__field_participatedulworkshopdidacticreduction5 = /** @type {(inputs: _Field_Participatedulworkshopdidacticreduction5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teilgenommen an ÜL-Workshop Didactic Reduction`)
};

/**

* @param {_Field_Participatedulworkshopdidacticreduction5Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_participatedulworkshopdidacticreduction5 = /** @type {((inputs?: _Field_Participatedulworkshopdidacticreduction5Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Participatedulworkshopdidacticreduction5Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_participatedulworkshopdidacticreduction5(inputs)
});
export { _field_participatedulworkshopdidacticreduction5 as "_field_participatedULWorkshopDidacticReduction" }